import { LOCALES } from "./Locales";

export const messages = {
  [LOCALES.ENGLISH]: {
    "app.heroText":
      "From Sedans to SUVs, Discover Your Ideal Used Car at Unbeatable Discounts!",
    "app.button.signin": "Sign in",
    "app.button.signout": "Sign out",
    "app.filter.title": "Filter by",
    "app.filter.brand": "Brand",
    "app.filter.model": "Model",
    "app.filter.year": "Year",
    "app.overview.title": "Overview",
    "app.overview.bodyTypeEn": "Body",
    "app.overview.yearOfManufacture": "Year",
    "app.overview.mileage": "Mileage",
    "app.overview.warrantyTillDate": "Warranty",
    "app.overview.numberOfDoors": "Doors",
    "app.overview.color": "Color",
    "app.overview.numberOfSeats": "Seats",
    "app.overview.cylinderCapacity": "Cylinder",
    "app.features.title": "Features & Specifications",
    "app.footer.about":
      "At Fazaa, we're redefining used car shopping. With a focus on quality, selection, and customer satisfaction, we offer a seamless experience from browsing to buying. Explore our rigorously inspected inventory and find your next ride with confidence. Welcome to the future of car buying.",
    "app.footer.importantLinks.title": "Important Links",
    "app.footer.importantLinks.dailyRent": "Daily Rent",
    "app.footer.importantLinks.longTermLease": "Long Term Car Lease",
    "app.footer.importantLinks.offers": "Offers",
    "app.footer.importantLinks.support": "Customer Support",
    "app.footer.importantLinks.policy": "Privacy policy",
    "app.footer.importantLinks.tnc": "Terms & Conditions",
    "app.footer.contact.title": "Contact Us",
    "app.footer.contact.tel": "Tel",
    "app.footer.contact.mail": "Mail",
    "app.footer.contact.whatsapp": "WhatsApp",
    "app.footer.follow.title": "Follow Us",
    "app.footer.copyright.title": "Copyright © 2024 Fazaa. All right reserved.",
    "app.title.contact": "Contact",
    "app.details.warrantyService": "Warranty & Service",
    "app.menu.logout": "Logout",
    "app.warranty.tillDate": "Warranty till date:",
    "app.warranty.tillKm": "Warranty till kilometeres:",
    "app.service.tillDate": "Service till date:",
    "app.service.tillKm": "Service till kilometeres:",
    "app.warranty.notes": "Warranty:",
    "app.service.notes": "Service:",
  },

  [LOCALES.ARABIC]: {
    "app.heroText":
      "من سيارات السيدان إلى سيارات الدفع الرباعي، اكتشف سيارتك المستعملة المثالية بخصومات لا تقبل المنافسة!",
    "app.button.signin": "تسجيل الدخول",
    "app.button.signout": "تسجيل الخروج",
    "app.filter.title": "مصنفة حسب",
    "app.filter.brand": "العلامة التجارية",
    "app.filter.model": "نموذج",
    "app.filter.year": "سنة",
    "app.overview.title": "ملخص",
    "app.overview.bodyTypeEn": "الهيكل",
    "app.overview.yearOfManufacture": "سنة",
    "app.overview.mileage": "عدد الأميال",
    "app.overview.warrantyTillDate": "ضمان",
    "app.overview.numberOfDoors": "أبواب",
    "app.overview.color": "لون",
    "app.overview.numberOfSeats": "مقاعد",
    "app.overview.cylinderCapacity": "اسطوانة",
    "app.features.title": "الميزات والمواصفات",
    "app.footer.about":
      "في فزعة، نقوم بإعادة تعريف التسوق للسيارات المستعملة. مع التركيز على الجودة والاختيار ورضا العملاء، فإننا نقدم تجربة سلسة بدءًا من التصفح وحتى الشراء. استكشف مخزوننا الذي تم فحصه بعناية وابحث عن رحلتك التالية بثقة. مرحبا بكم في مستقبل شراء السيارات.",
    "app.footer.importantLinks.title": "روابط مهمة",
    "app.footer.importantLinks.dailyRent": "استئجار سيارة",
    "app.footer.importantLinks.longTermLease":
      "تأجير السيارات على المدى الطويل",
    "app.footer.importantLinks.offers": "عروض",
    "app.footer.importantLinks.support": "دعم العملاء",
    "app.footer.importantLinks.policy": "سياسة الخصوصية",
    "app.footer.importantLinks.tnc": "الشروط والأحكام",
    "app.footer.contact.title": "اتصل بنا",
    "app.footer.contact.tel": "هاتف",
    "app.footer.contact.mail": "بريد",
    "app.footer.contact.whatsapp": "واتساب",
    "app.footer.follow.title": "تابعنا",
    "app.footer.copyright.title": "حقوق النشر © 2024 فزعة. جميع الحقوق محفوظة.",
    "app.title.contact": "اتصال",
    "app.details.warrantyService": "الضمان والخدمة",
    "app.menu.logout": "تسجيل خروج",
    "app.warranty.tillDate": "الضمان حتى تاريخه:",
    "app.warranty.tillKm": "الضمان حتى الكيلومترات:",
    "app.service.tillDate": "الخدمة حتى الآن:",
    "app.service.tillKm": "الخدمة حتى الكيلومترات:",
    "app.warranty.notes": "الضمان:",
    "app.service.notes": "الخدمة:",
  },
};
